import React from "react";
import { Link } from "react-router-dom";

function NotFoundPage() {
  return (
    <div className="mx-auto max-w-xl px-4 py-16 text-center">
      <h1 className="text-3xl font-bold">Страница не найдена</h1>
      <p className="mt-3 text-gray-500 dark:text-gray-400">
        Возможно, адрес изменился. Загляните в каталог или на главную.
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-indigo-600 px-4 py-2 font-semibold text-white hover:bg-indigo-500"
        >
          На главную
        </Link>
        <a
          href="/nintendo/igry"
          className="rounded-md border border-indigo-600 px-4 py-2 font-semibold text-indigo-600 hover:bg-indigo-50 dark:hover:bg-gray-800"
        >
          Игры Nintendo Switch
        </a>
      </div>
    </div>
  );
}

export default NotFoundPage;
